import keyMirror from 'keymirror'

export const IconStyles = keyMirror({
  SOLID1: null,
  SOLID2: null,
  OUTLINE1: null,
  OUTLINE2: null,
})

export const IconTypes = keyMirror({
  chatSrc: null,
  feedbackSrc: null,
  announcementSrc: null,
  npsSrc: null,
  dismiss: null,
})

export const IconPickerConfig = {
  [IconStyles.SOLID1]: {
    [IconTypes.chatSrc]: require('!svg-inline?removeSVGTagAttrs=false&removeTags=true!images/svg/widget-icons/solid1/chat.svg'),
    [IconTypes.feedbackSrc]: require('!svg-inline?removeSVGTagAttrs=false&removeTags=true!images/svg/widget-icons/solid1/feedback.svg'),
    [IconTypes.announcementSrc]: require('!svg-inline?removeSVGTagAttrs=false&removeTags=true!images/svg/widget-icons/solid1/announcement.svg'),
    [IconTypes.npsSrc]: require('!svg-inline?removeSVGTagAttrs=false&removeTags=true!images/svg/widget-icons/solid1/nps.svg'),
  },
  [IconStyles.SOLID2]: {
    [IconTypes.chatSrc]: require('!svg-inline?removeSVGTagAttrs=false&removeTags=true!images/svg/widget-icons/solid2/chat.svg'),
    [IconTypes.feedbackSrc]: require('!svg-inline?removeSVGTagAttrs=false&removeTags=true!images/svg/widget-icons/solid2/feedback.svg'),
    [IconTypes.announcementSrc]: require('!svg-inline?removeSVGTagAttrs=false&removeTags=true!images/svg/widget-icons/solid2/announcement.svg'),
    [IconTypes.npsSrc]: require('!svg-inline?removeSVGTagAttrs=false&removeTags=true!images/svg/widget-icons/solid2/nps.svg'),
  },
  [IconStyles.OUTLINE1]: {
    [IconTypes.chatSrc]: require('!svg-inline?removeSVGTagAttrs=false&removeTags=true!images/svg/widget-icons/outline1/chat.svg'),
    [IconTypes.feedbackSrc]: require('!svg-inline?removeSVGTagAttrs=false&removeTags=true!images/svg/widget-icons/outline1/feedback.svg'),
    [IconTypes.announcementSrc]: require('!svg-inline?removeSVGTagAttrs=false&removeTags=true!images/svg/widget-icons/outline1/announcement.svg'),
    [IconTypes.npsSrc]: require('!svg-inline?removeSVGTagAttrs=false&removeTags=true!images/svg/widget-icons/outline1/nps.svg'),
  },
  [IconStyles.OUTLINE2]: {
    [IconTypes.chatSrc]: require('!svg-inline?removeSVGTagAttrs=false&removeTags=true!images/svg/widget-icons/outline2/chat.svg'),
    [IconTypes.feedbackSrc]: require('!svg-inline?removeSVGTagAttrs=false&removeTags=true!images/svg/widget-icons/outline2/feedback.svg'),
    [IconTypes.announcementSrc]: require('!svg-inline?removeSVGTagAttrs=false&removeTags=true!images/svg/widget-icons/outline2/announcement.svg'),
    [IconTypes.npsSrc]: require('!svg-inline?removeSVGTagAttrs=false&removeTags=true!images/svg/widget-icons/outline2/nps.svg'),
  },
}



// WEBPACK FOOTER //
// ./src/scripts/components/Customize/Styling/IconPicker/Constants.js